import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputSelectField from '../../Fields/InputSelectField';


class SettingsBillingPanel extends React.Component {
  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'billing_day':
        case 'payment_due_day':
        case 'first_month_proration_day':
          if (value !== null) value = parseInt(value, 10);
          break;
        default:
      }

      this.props.onValueChange(inputId, value);
    };
  }


  render() {
    const {
      editMode,
      settings,
      fieldConfiguration
    } = this.props;

    const {
      facilitySettings: facilitySettingsFieldConfiguration
    } = fieldConfiguration;

    const requiredFieldState = editMode;

    const renderBillingDayField = settings.fields.billing_timing.value !== null;
    const renderPaymentDueDayField = (settings.fields.decline_recurring.value !== 'REQUIRED');

    const billingDayOptions = facilitySettingsFieldConfiguration.billing_day.options[settings.fields.billing_timing.value];

    return (
      <div>
        <FieldGroup label="Billing Rules">
          <Field label="Decline Recurring"
            id="parkchirp--settings--decline-recurring"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--settings--decline-recurring"
              value={settings.fields.decline_recurring.value}
              options={facilitySettingsFieldConfiguration.decline_recurring.options}
              onChange={this._onInputChange('decline_recurring')}
              editMode={editMode}
            />
          </Field>
          <Field label="Billing Timing"
            id="parkchirp--settings--billing-timing"
            required={requiredFieldState}
            layout="columns">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <InputSelectField inputId="parkchirp--settings--billing-timing"
                value={settings.fields.billing_timing.value}
                options={facilitySettingsFieldConfiguration.billing_timing.options}
                onChange={this._onInputChange('billing_timing')}
                editMode={editMode}
              />
              {(renderBillingDayField) &&
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  {(settings.fields.billing_timing.value === 'CALENDAR_DAY') &&
                    <span style={{ marginLeft: '0.3em', marginRight: '0.3em' }}>on the</span>
                  }
                  {(settings.fields.billing_timing.value === 'ROLLING_PERIOD' ) &&
                    <span style={{ marginRight: '0.3em' }}>,&nbsp;</span>
                  }
                  <InputSelectField inputId="parkchirp--settings--billing-day"
                    value={settings.fields.billing_day.value}
                    options={billingDayOptions}
                    onChange={this._onInputChange('billing_day')}
                    editMode={editMode}
                  />
                  {(settings.fields.billing_timing.value === 'CALENDAR_DAY') &&
                    <span style={{ marginLeft: '0.3em' }}>day of the month</span>
                  }
                  {(settings.fields.billing_timing.value === 'ROLLING_PERIOD' ) &&
                    <span style={{ marginLeft: '0.3em' }}>day(s) prior to start of new billing period</span>
                  }
                </div>
              }
            </div>
          </Field>
          {(renderPaymentDueDayField) &&
            <Field label="Payment Due Date"
              id="parkchirp--settings--payment-due-day"
              required={requiredFieldState}
              layout="columns">
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <InputSelectField inputId="parkchirp--settings--payment-due-day"
                  value={settings.fields.payment_due_day.value}
                  options={facilitySettingsFieldConfiguration.payment_due_day.options}
                  onChange={this._onInputChange('payment_due_day')}
                  editMode={editMode}
                />
                <span style={{ marginLeft: '0.3em' }}>day of the month</span>
              </div>
            </Field>
          }
          <Field label="First Month Proration"
            id="parkchirp--settings--first-month-proration"
            required={requiredFieldState}
            layout="columns">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <InputSelectField inputId="parkchirp--settings--first-month-proration"
                value={settings.fields.first_month_proration.value}
                options={facilitySettingsFieldConfiguration.first_month_proration.options}
                onChange={this._onInputChange('first_month_proration')}
                editMode={editMode}
              />
              {(settings.fields.first_month_proration.value === 'HALF_MONTH') &&
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '0.3rem' }}>
                  <span style={{ marginRight: '0.3em' }}>on or after the</span>
                  <InputSelectField inputId="parkchirp--settings--first-month-proration-day"
                    value={settings.fields.first_month_proration_day.value}
                    options={facilitySettingsFieldConfiguration.first_month_proration_day.options}
                    onChange={this._onInputChange('first_month_proration_day')}
                    editMode={editMode}
                  />
                  <span style={{ marginLeft: '0.3em' }}>day of the month</span>
                </div>
              }
            </div>
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default SettingsBillingPanel;
